import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { MDBContainer } from "mdbreact";
import Navigation from "./Components/Navigation";
import Footer from "./Components/Footer";
import ComponentRoutes from '../Utilities/ComponentRoutes';
import Loader from "../Components/ComponentFragments/Loader";
import DataLayer from '../Utilities/DataLayer';
import Challenges from "../Components/Challenges";

class Salesforce extends Component {
    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = {
            breakWidth: 1400,
            windowWidth: 0,
            navItems: [],
            showLoader: true,
            cartItemCount: this.TMAUser.data.cartItemCount,
            cartHidden: false,
            cartZoneId: -1,
            routeParam: '',
            shopCategories: [],
            mediaCategories: [],
            currentBalance: 0,
            allowTuppSocial: false,
            managerName: '',
            unitName: '',
            managerCell: '',
            tuppSocialUrl: '',
            connectUrl: '',
            share: false,
            bankInfoHidden: false,
            challenges: [],
            levelPercentage: '',
            levelName: ''
        }

        this.loaderOn = this.loaderOn.bind(this);
        this.loaderOff = this.loaderOff.bind(this);
        this.updateCartCount = this.updateCartCount.bind(this);
        this.showHideCart = this.showHideCart.bind(this);
        this.setSelectedZoneId = this.setSelectedZoneId.bind(this);
        this.getSelectedZoneId = this.getSelectedZoneId.bind(this);
        this.getRouteParam = this.getRouteParam.bind(this);
        this.setRouteParam = this.setRouteParam.bind(this);
        this.showHideNode = this.showHideNode.bind(this);
        this.getConnectUrl = this.getConnectUrl.bind(this);
    }

    getConnectUrl() {
        return this.state.connectUrl;
    }

    showHideNode(nodeId, show) {
        var nItems = this.state.navItems;
        for (var i = 0; i < nItems.length; i++) {
            if (nItems[i].id != undefined) {
                if (nItems[i].id == nodeId) {
                    nItems[i].nodeHidden = show;
                }
            }
        }
        this.setState({ navItems: nItems });
    }

    async componentWillMount() {
        try {
            var dl = new DataLayer();
            let response = await dl.Get('/shop/getshopcategories');
            let categoryResponse = await dl.Get('/common/getmediacategories');
            let balResponse = await dl.Get('/demonstrator/getCurrentBalance');
            let managerDetail = await dl.Get('/demonstrator/getManagerDetail');
            let challengesResponse = await dl.Get('/challenges/getChallenges');
            let nodes = response.data;

            let mName = "";
            let mCell = "";
            let uName = "";
            if (this.TMAUser.data.statusCode1 == "D") {
                mName = managerDetail.data.firstNames + ' ' + managerDetail.data.surname;
                mCell = managerDetail.data.telephoneCell;
                uName = managerDetail.data.unitName;
            }

            this.setState({
                shopCategories: nodes,
                currentBalance: balResponse.data[0].Balance * -1,
                bankInfoHidden: balResponse.data[0].Share == 1 ? false : true,
                mediaCategories: categoryResponse.data,
                managerName: mName,
                managerCell: mCell,
                unitName: uName,
                tuppSocialUrl: managerDetail.data.tuppSocialUrl,
                connectUrl: managerDetail.data.connectUrl,
                share: managerDetail.data.share,
                challenges: challengesResponse.data,
                levelPercentage: managerDetail.data.levelPercentage == -1 ? '' : managerDetail.data.levelPercentage,
                levelName: managerDetail.data.levelPercentage == -1 ? 'Disc\' Lvl Not Set' : managerDetail.data.levelName
            });
            //****************** put back
            //if (this.TMAUser.data.acceptedTerms) {
            if (balResponse.data[0].AcceptedTerms == 1) {
                this.setSideBarItems();
            } else {
                const { history } = this.props;
                history.push('/termsandconditions');
            }
            //}
        } catch (ex) {
            alert(ex);
        }
    }

    componentDidMount = () => {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        //this.setSideBarItems();
        this.setState({
            cartItemCount: this.TMAUser.data.cartItemCount,
            cartHidden: this.TMAUser.data.loginType == 'SF' ? false : true,
            allowTuppSocial: this.TMAUser.data.allowTuppSocial
        })
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.handleResize);
    }

    loaderOn() {
        if (!this.state.showLoader) {
            this.setState({ showLoader: true });
        }
    }

    loaderOff() {
        if (this.state.showLoader) {
            this.setState({ showLoader: false });
        }
    }

    setSelectedZoneId(zoneId) {
        this.setState({
            cartZoneId: zoneId
        })
    }

    setRouteParam(param) {
        this.setState({
            routeParam: param
        })
    }


    getRouteParam() {
        return this.state.routeParam
    }

    getSelectedZoneId() {
        return this.state.cartZoneId
    }

    showHideCart(hide) {
        this.setState({
            cartHidden: hide
        });
    }

    updateCartCount(value) {
        this.TMAUser.data.cartItemCount = value;
        localStorage.setItem("TMAUser", JSON.stringify(this.TMAUser));
        this.setState({
            cartItemCount: value
        })
    }

    handleResize = () =>
        this.setState({
            windowWidth: window.innerWidth
        });

    setSideBarItems() {
        let navItems = [];
        switch (this.TMAUser.data.loginType) {
            case 'SF':
                switch (this.TMAUser.data.statusCode1) {
                    case 'D':
                        navItems.push(
                            { 'route': '/salesforce', 'text': 'Home', 'iconClass': '', 'iconName': 'home' },
                            { 'route': '/salesforce/recruitlink', 'text': 'Recruit Link', 'iconClass': '', 'iconName': 'user-plus' },
                            { 'route': '/salesforce/dashboard', 'text': 'Dashboard', 'iconClass': '', 'iconName': 'tachometer-alt' },
                            { 'route': '/salesforce/personalInfo', 'text': 'Personal Info', 'iconClass': '', 'iconName': 'user-edit' },
                        );

                        if (this.TMAUser.data.countryId == 6) {
                            navItems.push(
                                { 'route': '/salesforce/bankingInfo', 'text': 'Banking Info', 'iconClass': '', 'iconName': 'money-check-alt', 'nodeHidden': this.state.bankInfoHidden, "id": "bInfo" }
                            );
                        }

                        navItems.push(
                            { 'route': '/salesforce/media', 'id': 'nodeMedia', 'text': 'Media', 'iconClass': '', 'iconName': 'video', 'children': this.state.mediaCategories }
                        );

                        if (this.TMAUser.data.mobiOrderingAllowed) {
                            navItems.push({
                                'route': '/salesforce/shop', 'id': 'nodeShop', 'text': 'Shop', 'iconClass': '', 'iconName': 'shopping-cart'
                                , 'children': this.state.shopCategories
                            })
                        };
                        if (this.TMAUser.data.experienceCenterOn) {
                            navItems.push({ 'route': '/salesforce/experiencecenter', 'text': 'Experience Center', 'iconClass': '', 'iconName': 'warehouse' })
                        }
                        navItems.push(
                            { 'route': '/salesforce/challenges', 'text': 'Challenges / Incentives', 'iconClass': '', 'iconName': 'medal' },
                            { 'route': '/salesforce/myorders', 'text': 'My Orders', 'iconClass': '', 'iconName': 'file-invoice-dollar' },
                            { 'route': '/salesforce/recruit', 'text': 'New Recruit', 'iconClass': '', 'iconName': 'user-plus' },
                            { 'route': '/salesforce/demonstratorlist/1', 'text': 'My Recruits', 'iconClass': '', 'iconName': 'users' },
                            { 'route': '/salesforce/demonstratorwithkit', 'text': 'Who\'s Kitted', 'iconClass': '', 'iconName': 'user-plus' },
                            { 'route': '/salesforce/inactive', 'text': 'Inactive Recruits', 'iconClass': '', 'iconName': 'user-clock' }
                            //{
                            //    'route': '/salesforce/train', 'id': 'nodeReports', 'text': 'Training', 'iconClass': '', 'iconName': 'anchor', children: [
                            //        { 'route': '/salesforce/inspire', 'text': 'Inspire Training', 'iconClass': '', 'iconName': 'diagnoses' },
                            //        { 'route': '/salesforce/ignite', 'text': 'Ignite Training', 'iconClass': '', 'iconName': 'diagnoses' }
                            //    ]
                            //}
                        );

                        this.setState({
                            navItems
                        })

                        break;
                    case 'M':
                        navItems.push(
                            //{
                            //    'route': '/salesforce/challenges', 'id':'nodeChallenges', 'text': 'Challenges / Incentives', 'iconClass': '', 'iconName': 'medal'
                            //    , 'children': this.state.challenges
                            //},
                            { 'route': '/salesforce', 'text': 'Home', 'iconClass': '', 'iconName': 'home' },
                            { 'route': '/salesforce/recruitlink', 'text': 'Recruit Link', 'iconClass': '', 'iconName': 'user-plus' },
                            { 'route': '/salesforce/dashboard', 'text': 'Dashboard', 'iconClass': '', 'iconName': 'tachometer-alt' },
                            //{ 'route': '/salesforce/challenges', 'text': 'Challenges / Incentives', 'iconClass': '', 'iconName': 'medal' },
                            { 'route': '/salesforce/rankings', 'text': 'Africa Rankings', 'iconClass': '', 'iconName': 'globe-africa' },
                            { 'route': '/salesforce/personalInfo', 'text': 'Personal Info', 'iconClass': '', 'iconName': 'user-edit' },
                        );

                        if (this.TMAUser.data.countryId == 6) {
                            navItems.push(
                                { 'route': '/salesforce/bankingInfo', 'text': 'Banking Info', 'iconClass': '', 'iconName': 'money-check-alt', 'nodeHidden': this.state.bankInfoHidden, "id": "bInfo" }
                            );
                        }

                        navItems.push(
                            { 'route': '/salesforce/media', 'id': 'nodeMedia', 'text': 'Media', 'iconClass': '', 'iconName': 'video', 'children': this.state.mediaCategories }
                        );

                        if (this.TMAUser.data.mobiOrderingAllowed) {
                            navItems.push({
                                'route': '/salesforce/shop', 'id': 'nodeShop', 'text': 'Shop', 'iconClass': '', 'iconName': 'shopping-cart'
                                , 'children': this.state.shopCategories
                            })

                        };
                        if (this.TMAUser.data.experienceCenterOn) {
                            navItems.push({ 'route': '/salesforce/experiencecenter', 'text': 'Experience Center', 'iconClass': '', 'iconName': 'warehouse' })
                        }
                        navItems.push(
                            {
                                'route': '/salesforce/myorders', 'id': 'nodeSalesTracking', 'text': 'Sales / Order Tracking', 'iconClass': '', 'iconName': 'dollar-sign', children: [
                                    { 'route': '/salesforce/myorders', 'text': 'My Orders', 'iconClass': '', 'iconName': 'file-invoice-dollar' },
                                    { 'route': '/salesforce/sales', 'text': 'Who\'s Selling', 'iconClass': '', 'iconName': 'dollar-sign' }
                                ]
                            },
                            {
                                'route': '/salesforce/recruit', 'id': 'nodeRecruiting', 'text': 'Recruiting', 'iconClass': '', 'iconName': 'users', 'children': [
                                    { 'route': '/salesforce/recruit', 'text': 'New Recruit', 'iconClass': '', 'iconName': 'user-plus' },
                                    { 'route': '/salesforce/demonstratorlist/1', 'text': 'My Recruits', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/recruiting', 'text': 'Who\'s Recruiting', 'iconClass': '', 'iconName': 'user-plus' },
                                    { 'route': '/salesforce/demonstratorwithkit', 'text': 'Who\'s Kitted', 'iconClass': '', 'iconName': 'user-plus' }
                                ]
                            },
                            {
                                'route': '/salesforce/earningscalculator', 'text': 'Earnings Calculator', 'iconClass': '', 'iconName': 'calculator'
                            },
                            {
                                'route': '/salesforce/kpis', 'id': 'nodeKpis', 'text': 'KPI Tracking', 'iconClass': '', 'iconName': 'chart-line', children: [
                                    { 'route': '/salesforce/teamPerformanceSummary', 'text': 'Unit Performance Summary', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/unitPerformanceDetail', 'text': 'Unit Performance Detail', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/recruitTracking', 'text': 'Recruit Tracking', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/inactive', 'text': 'Inactive Demonstrators', 'iconClass': '', 'iconName': 'user-clock' }
                                    //,
                                    //{ 'route': '/salesforce/getup', 'text': 'Get Up', 'iconClass': '', 'iconName': 'users' }
                                ]
                            },
                            {
                                'route': '/salesforce/unitReports', 'id': 'nodeReports', 'text': 'Reports', 'iconClass': '', 'iconName': 'list-ol', children: [
                                    //{ 'route': '/salesforce/challenges', 'text': 'Challenges / Incentives', 'iconClass': '', 'iconName': 'medal' },
                                    { 'route': '/salesforce/demonstratorlist/0', 'text': 'Demonstrators', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/threestepdemonstrators', 'text': '3 Step Demonstrators', 'iconClass': '', 'iconName': 'user-graduate' },
                                    { 'route': '/salesforce/mobileleads', 'text': 'Leads', 'iconClass': '', 'iconName': 'star' },
                                    { 'route': '/salesforce/watchlist', 'text': 'Watch List', 'iconClass': '', 'iconName': 'glasses' },
                                    { 'route': '/salesforce/potentialmanagers', 'text': 'Potential Managers', 'iconClass': '', 'iconName': 'award' },
                                    { 'route': '/salesforce/potentialteamleader', 'text': 'Potential Team Leaders', 'iconClass': '', 'iconName': 'award' },
                                    { 'route': '/salesforce/promoteouts', 'text': 'My Promoteouts', 'iconClass': '', 'iconName': 'user-friends' },
                                    { 'route': '/salesforce/teamtransactions', 'text': 'Unit Transactions', 'iconClass': '', 'iconName': 'list-ol' },
                                    { 'route': '/salesforce/training', 'text': 'Demonstrator Training', 'iconClass': '', 'iconName': 'users' },
                                ]
                            }
                            //{
                            //    'route': '/salesforce/train', 'id': 'nodeReports', 'text': 'Training', 'iconClass': '', 'iconName': 'anchor', children: [
                            //        { 'route': '/salesforce/inspire', 'text': 'Inspire Training', 'iconClass': '', 'iconName': 'diagnoses' },
                            //        { 'route': '/salesforce/ignite', 'text': 'Ignite Training', 'iconClass': '', 'iconName': 'diagnoses' }
                            //    ]
                            //}
                        );

                        this.setState({
                            navItems
                        })
                        break;
                    case 'T':
                        //this.TMAUser.data.mobiOrderingAllowed
                        //, 'children': [{ 'route': '/salesforce/sales', 'text': 'Sub Cat 1', 'iconClass': '', 'iconName': 'dollar-sign'}]
                        navItems.push(
                            //{ 'route': '/salesforce/challenges', 'text': 'Challenges / Incentives', 'iconClass': '', 'iconName': 'medal' },
                            //{ 'route': '/salesforce/testpage', 'text': 'Test Page', 'iconClass': '', 'iconName': 'dollar' },
                            { 'route': '/salesforce', 'text': 'Home', 'iconClass': '', 'iconName': 'home' },
                            { 'route': '/salesforce/recruitlink', 'text': 'Recruit Link', 'iconClass': '', 'iconName': 'user-plus' },
                            { 'route': '/salesforce/dashboard', 'text': 'Dashboard', 'iconClass': '', 'iconName': 'tachometer-alt' },
                            { 'route': '/salesforce/goals', 'text': 'Goals', 'iconClass': '', 'iconName': 'medal' },
                            { 'route': '/salesforce/rankings', 'text': 'Africa Rankings', 'iconClass': '', 'iconName': 'globe-africa' },
                            { 'route': '/salesforce/personalInfo', 'text': 'Personal Info', 'iconClass': '', 'iconName': 'user-edit' }
                        );

                        if (this.TMAUser.data.countryId == 6) {
                            navItems.push(
                                { 'route': '/salesforce/bankingInfo', 'text': 'Banking Info', 'iconClass': '', 'iconName': 'money-check-alt', 'nodeHidden': this.state.bankInfoHidden, "id": "bInfo" }
                            );
                        }

                        navItems.push(
                            { 'route': '/salesforce/media', 'id': 'nodeMedia', 'text': 'Media', 'iconClass': '', 'iconName': 'video', 'children': this.state.mediaCategories }
                        );

                        if (this.TMAUser.data.mobiOrderingAllowed) {
                            navItems.push({
                                'route': '/salesforce/shop', 'id': 'nodeShop', 'text': 'Shop Categories', 'iconClass': '', 'iconName': 'shopping-cart'
                                , 'children': this.state.shopCategories
                            })
                        };
                        if (this.TMAUser.data.experienceCenterOn) {
                            navItems.push({ 'route': '/salesforce/experiencecenter', 'text': 'Experience Center', 'iconClass': '', 'iconName': 'warehouse' })
                        }
                        navItems.push(
                            {
                                'route': '/salesforce/myorders', 'id': 'nodeSalesTracking', 'text': 'Sales / Order Tracking', 'iconClass': '', 'iconName': 'dollar-sign', children: [
                                    { 'route': '/salesforce/myorders', 'text': 'My Orders', 'iconClass': '', 'iconName': 'file-invoice-dollar' },
                                    { 'route': '/salesforce/sales', 'text': 'Who\'s Selling', 'iconClass': '', 'iconName': 'dollar-sign' }
                                ]
                            },
                            {
                                'route': '/salesforce/recruit', 'id': 'nodeRecruiting', 'text': 'Recruiting', 'iconClass': '', 'iconName': 'users', 'children': [
                                    { 'route': '/salesforce/recruit', 'text': 'New Recruit', 'iconClass': '', 'iconName': 'user-plus' },
                                    { 'route': '/salesforce/demonstratorlist/1', 'text': 'My Recruits', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/recruiting', 'text': 'Who\'s Recruiting', 'iconClass': '', 'iconName': 'user-plus' },
                                    { 'route': '/salesforce/demonstratorwithkit', 'text': 'Who\'s Kitted', 'iconClass': '', 'iconName': 'box-open' }
                                ]
                            },
                            {
                                'route': '/salesforce/earningscalculator', 'text': 'Earnings Calculator', 'iconClass': '', 'iconName': 'calculator'
                            },
                            {
                                'route': '/salesforce/kpis', 'id': 'nodeKpis', 'text': 'KPI Tracking', 'iconClass': '', 'iconName': 'chart-line', children: [
                                    { 'route': '/salesforce/teamPerformanceSummary', 'text': 'Team Performance Summary', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/teamUnitsPerformance', 'text': 'Team Units Performance', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/teamPerformance', 'text': 'Detailed Team Performance', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/recruitTracking', 'text': 'Recruit Tracking', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/teamUnitHealth', 'text': 'Units Health Check', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/inactive', 'text': 'Inactive Demonstrators', 'iconClass': '', 'iconName': 'user-clock' }
                                    //,
                                    //{ 'route': '/salesforce/recruitAnalysis', 'text': 'Recruit Analysis', 'iconClass': '', 'iconName': 'users' },
                                    //{ 'route': '/salesforce/getup', 'text': 'Get Up', 'iconClass': '', 'iconName': 'users' }
                                ]
                            },
                            {
                                'route': '/salesforce/teamtransactions', 'id': 'nodeReports', 'text': 'Reports', 'iconClass': '', 'iconName': 'list-ol', children: [
                                    { 'route': '/salesforce/unitlist', 'text': 'Units', 'iconClass': '', 'iconName': 'users' },
                                    { 'route': '/salesforce/achievers', 'text': 'Top Achievers', 'iconClass': '', 'iconName': 'trophy' },
                                    { 'route': '/salesforce/threestepmanagers', 'text': '3 Step Managers', 'iconClass': '', 'iconName': 'user-graduate' },
                                    { 'route': '/salesforce/threestepdemonstrators', 'text': '3 Step Demonstrators', 'iconClass': '', 'iconName': 'user-graduate' },
                                    { 'route': '/salesforce/mobileleads', 'text': 'Leads', 'iconClass': '', 'iconName': 'star' },
                                    { 'route': '/salesforce/watchlist', 'text': 'Watch List', 'iconClass': '', 'iconName': 'glasses' },
                                    { 'route': '/salesforce/teamtransactions', 'text': 'Team Transactions', 'iconClass': '', 'iconName': 'list-ol' },
                                    { 'route': '/salesforce/teamactivity', 'text': 'Team Activity', 'iconClass': '', 'iconName': 'chart-bar' },
                                    { 'route': '/salesforce/potentialmanagers', 'text': 'Potential Managers', 'iconClass': '', 'iconName': 'award' },
                                    { 'route': '/salesforce/potentialteamleader', 'text': 'Potential Team Leaders', 'iconClass': '', 'iconName': 'award' },
                                    { 'route': '/salesforce/training', 'text': 'Demonstrator Training', 'iconClass': '', 'iconName': 'users' },
                                ]
                            }
                            //{
                            //    'route': '/salesforce/train', 'id': 'nodeReports', 'text': 'Training', 'iconClass': '', 'iconName': 'anchor', children: [
                            //        { 'route': '/salesforce/inspire', 'text': 'Inspire Training', 'iconClass': '', 'iconName': 'diagnoses' },
                            //        { 'route': '/salesforce/ignite', 'text': 'Ignite Training', 'iconClass': '', 'iconName': 'diagnoses' },
                                    
                            //    ]
                            //}
                        );

                        //navItems.push(
                        //   // { 'route': '/salesforce/challenges', 'text': 'Challenges / Incentives', 'iconClass': '', 'iconName': 'medal' },
                        //    { 'route': '/salesforce/recruit', 'text': 'New Recruit', 'iconClass': '', 'iconName': 'user-plus' }, DONE
                        //    { 'route': '/salesforce/demonstratorlist/1', 'text': 'My Recruits', 'iconClass': '', 'iconName': 'users' }, DONE
                        //    { 'route': '/salesforce/myorders', 'text': 'My Orders', 'iconClass': '', 'iconName': 'file-invoice-dollar' }, DONE
                        //    { 'route': '/salesforce/unitlist', 'text': 'Units', 'iconClass': '', 'iconName': 'users' }, DONE
                        //    { 'route': '/salesforce/earningscalculator', 'text': 'Earnings Calculator', 'iconClass': '', 'iconName': 'calculator' },
                        //    { 'route': '/salesforce/achievers', 'text': 'Top Achievers', 'iconClass': '', 'iconName': 'trophy' }, DONE
                        //    { 'route': '/salesforce/threestepmanagers', 'text': '3 Step Managers', 'iconClass': '', 'iconName': 'user-graduate' }, DONE
                        //    { 'route': '/salesforce/threestepdemonstrators', 'text': '3 Step Demonstrators', 'iconClass': '', 'iconName': 'user-graduate' }, DONE
                        //    { 'route': '/salesforce/mobileleads', 'text': 'Leads', 'iconClass': '', 'iconName': 'star' }, DONE
                        //    { 'route': '/salesforce/watchlist', 'text': 'Watch List', 'iconClass': '', 'iconName': 'glasses' }, DONE
                        //    { 'route': '/salesforce/teamtransactions', 'text': 'Team Transactions', 'iconClass': '', 'iconName': 'list-ol' }, DONE
                        //    { 'route': '/salesforce/teamactivity', 'text': 'Team Activity', 'iconClass': '', 'iconName': 'chart-bar' }, DONE
                        //    { 'route': '/salesforce/potentialmanagers', 'text': 'Potential Managers', 'iconClass': '', 'iconName': 'award' }, DONE
                        //    { 'route': '/salesforce/potentialteamleader', 'text': 'Potential Team Leaders', 'iconClass': '', 'iconName': 'award' }, DONE
                        //    { 'route': '/salesforce/recruiting', 'text': 'Who\'s Recruiting', 'iconClass': '', 'iconName': 'user-plus' }, DONE
                        //    { 'route': '/salesforce/sales', 'text': 'Who\'s Selling', 'iconClass': '', 'iconName': 'dollar-sign' }, DONE
                        //    { 'route': '/salesforce/testpage', 'text': 'Test Page', 'iconClass': '', 'iconName': 'dollar' }
                        //);

                        this.setState({
                            navItems
                        })
                        break;
                    default:
                }
                break;
            case 'DS':
                this.setState({
                    navItems: [ // when adding new routes here you must add route to the utilities/ComponentRoutes file too.
                        //{ 'route': '/', 'text': 'Distributor', 'iconClass': '', 'iconName': '' },
                        { 'route': '/salesforce/virtualstore', 'text': 'Shop', 'iconClass': '', 'iconName': 'shopping-cart' },
                        { 'route': '/salesforce/dsGoals', 'text': 'DS Goals', 'iconClass': '', 'iconName': 'medal' }
                    ]
                })
                break;
            case 'HO':
                this.setState({
                    navItems: [ // when adding new routes here you must add route to the utilities/ComponentRoutes file too.
                        //{ 'route': '/', 'text': 'Head Office', 'iconClass': '', 'iconName': '' },
                        { 'route': '/salesforce/virtualstore', 'text': 'Shop', 'iconClass': '', 'iconName': 'shopping-cart' },
                        { 'route': '/salesforce/dsGoals', 'text': 'DS Goals', 'iconClass': '', 'iconName': 'medal' }
                    ]
                })
                break;
            case 'SU':
                this.setState({
                    navItems: [ // when adding new routes here you must add route to the utilities/ComponentRoutes file too.
                        //{ 'route': '/salesforce/dashboard', 'text': 'Campaign', 'iconClass': '', 'iconName': '' },
                        { 'route': '/salesforce/virtualstore', 'text': 'Shop', 'iconClass': '', 'iconName': 'shopping-cart' },
                        { 'route': '/salesforce/dsGoals', 'text': 'DS Goals', 'iconClass': '', 'iconName': 'medal' }
                    ]
                })
                break;
            default:
                break;
        }
    }
    //0814630726
    //b450006756

    //sp
    //0861787377
    //ref 4710120079082
    // wo73623
    // 0832004828 whats app support

    render() {
        const mainStyle = {
            paddingTop: "3rem",
            paddingBottom: "3rem",
            paddingRight: "1rem",
            paddingLeft:
                this.state.windowWidth > this.state.breakWidth ? "250px" : "0"
        };

        return (
            <Router>
                <div>
                    <Loader showLoader={this.state.showLoader} />
                </div>
                <div>
                    <Navigation levelPercentage={this.state.levelPercentage} levelName={ this.state.levelName} connectUrl={this.state.connectUrl} tuppSocialUrl={this.state.tuppSocialUrl} managerName={this.state.managerName} unitName={this.state.unitName} managerCell={this.state.managerCell} currentBalance={this.state.currentBalance} setNavParam={this.setRouteParam} share={this.state.share} allowTuppSocial={this.state.allowTuppSocial} cartHidden={this.state.cartHidden} cartItemCount={this.state.cartItemCount} navItems={this.state.navItems} />
                    <main style={mainStyle}>
                        <MDBContainer fluid className="mt-5">
                            <ComponentRoutes discountAssigned={this.state.levelPercentage === '' ? false : true } share={this.state.share} getConnectUrl={this.getConnectUrl} setNavParam={this.setRouteParam} getRouteParam={this.getRouteParam} setSelectedZoneId={this.setSelectedZoneId} getSelectedZoneId={this.getSelectedZoneId} showHideCart={this.showHideCart} showHideNode={this.showHideNode} updateCartCount={this.updateCartCount} loaderOn={this.loaderOn} loaderOff={this.loaderOff} />
                        </MDBContainer>
                    </main>

                </div>
                <div style={{ zIndex: "-1" }}><Footer /></div>
            </Router>
        );
    }
}

export default Salesforce;
